module.exports = __webpack_public_path__ + "static/media/smartroll.c897499f.jpg";